const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.3501,
    width: 63.3,
    height: 63.3,
    rx: 31.65,
    fill: "white",
    fillOpacity: 0.1,
    style: {
      fill: "white",
      fillOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.3501,
    width: 63.3,
    height: 63.3,
    rx: 31.65,
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0855 33.7858C41.5195 33.3518 41.5195 32.6482 41.0855 32.2142L34.013 25.1416C33.579 24.7076 32.8753 24.7076 32.4413 25.1416C32.0073 25.5756 32.0073 26.2793 32.4413 26.7133L38.728 33L32.4413 39.2867C32.0073 39.7207 32.0073 40.4244 32.4413 40.8584C32.8753 41.2924 33.579 41.2924 34.013 40.8584L41.0855 33.7858ZM24 34.1113H40.2997V31.8887H24V34.1113Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowWhite);
export default __webpack_public_path__ + "static/media/icon-arrow-white.1921fbd8dd50ed26b0aa35385b8ba96e.svg";
export { ForwardRef as ReactComponent };